/* Bull Tallow Theme JS */
(function() {
  'use strict';

  /* Reveal-on-scroll animations */
  function initRevealAnimations() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* Format cents as USD currency string, matching Shopify's money filter output */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return '$' + amount;
  }

  /* Swap an existing cart line for the Buy 2 Get 1 Free bundle variant of the same product */
  function upgradeLineToBundle(line, bundleVariantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function() {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(bundleVariantId, 10), quantity: 1 }] })
        });
      })
      .then(function() {
        window.location.reload();
      })
      .catch(function() {
        window.location.reload();
      });
  }

  /* Update a single cart line's quantity via the AJAX Cart API and refresh prices on the page */
  function updateCartLineQuantity(selector, line, quantity) {
    var cartItem = selector.closest('.cart-item');
    var priceEl = cartItem ? cartItem.querySelector('.cart-item__price') : null;
    var subtotalEl = document.querySelector('.cart__subtotal-price');
    var cartCountEl = document.querySelector('.header__cart-count');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function(cart) {
        var item = cart.items[parseInt(line, 10) - 1];

        if (item && priceEl) {
          priceEl.textContent = formatMoney(item.final_line_price);
        }

        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }

        if (cartCountEl) {
          cartCountEl.textContent = cart.item_count;
        }

        /* If the whole cart emptied out (last item removed via minus/remove), reload to show empty state */
        if (cart.item_count === 0) {
          window.location.reload();
        }
      })
      .catch(function() {
        /* Fall back to a full reload so the cart state shown is never wrong */
        window.location.reload();
      });
  }

  /* Quantity selector */
  function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      var input = selector.querySelector('input');
      var minus = selector.querySelector('[data-action="minus"]');
      var plus = selector.querySelector('[data-action="plus"]');
      var line = input ? input.getAttribute('data-line') : null;

      var isBundleLine = input.getAttribute('data-is-bundle') === 'true';
      var bundleVariantId = input.getAttribute('data-bundle-variant-id');

      function applyCartQuantity(val) {
        if (line && !isBundleLine && val >= 2 && bundleVariantId) {
          upgradeLineToBundle(line, bundleVariantId);
          return;
        }
        updateCartLineQuantity(selector, line, val);
      }

      if (minus) {
        minus.addEventListener('click', function() {
          var val = parseInt(input.value, 10);
          if (val > 1) {
            val = val - 1;
            input.value = val;
            if (line) {
              applyCartQuantity(val);
            } else {
              input.dispatchEvent(new Event('change'));
            }
          }
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          var val = parseInt(input.value, 10) + 1;
          input.value = val;
          if (line) {
            applyCartQuantity(val);
          } else {
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      /* Support typing a quantity directly into the number field on the cart page */
      if (line) {
        input.addEventListener('change', function() {
          var val = parseInt(input.value, 10);
          if (isNaN(val) || val < 1) {
            val = 1;
            input.value = val;
          }
          applyCartQuantity(val);
        });
      }
    });
  }

  /* Mobile menu toggle */
  function initMobileMenu() {
    var toggle = document.querySelector('.header__menu-toggle');
    var nav = document.querySelector('.header__nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      nav.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }

  /* Product form - Add to cart */
  function initProductForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.textContent = 'Adding...';
          submitBtn.disabled = true;
        }
      });
    });
  }

  /* Init all */
  document.addEventListener('DOMContentLoaded', function() {
    initRevealAnimations();
    initQuantitySelectors();
    initMobileMenu();
    initProductForms();
  });
})();
